
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/fivetran",
      function () {
        return require("private-next-pages/extensions/fivetran.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/fivetran"])
      });
    }
  